<template>
  <DataFiltro :filtro="filtro" :path="path" />
</template>
<script>
import DataFiltro from './DataFiltro.vue';
export default {
  components: { DataFiltro },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  }
}
</script>
